import { useState, useEffect, createContext, useContext } from 'react'
import { useAuth } from './useAuth'
import { getMyMembership } from '../lib/supabase'

const PracticeContext = createContext(null)

export function PracticeProvider({ children }) {
  const { user, loading: authLoading } = useAuth()
  const [practiceId, setPracticeId] = useState(null)
  const [role, setRole]             = useState(null)
  const [loading, setLoading]       = useState(true)

  useEffect(() => {
    if (authLoading) return
    if (!user) { setLoading(false); return }

    getMyMembership().then(({ data, error }) => {
      if (error) {
        console.error('Failed to load membership:', error.message)
        // Don't silently escalate — leave practiceId/role as null so the UI
        // can't grant owner-level access due to a lookup failure.
        setLoading(false)
        return
      }
      if (data?.practice_id && data?.role) {
        setPracticeId(data.practice_id)
        setRole(data.role)
      } else {
        // Fallback for brand new accounts before trigger creates the row
        setPracticeId(user.id)
        setRole('owner')
      }
      setLoading(false)
    })
  }, [user, authLoading])

  return (
    <PracticeContext.Provider value={{ practiceId, role, loading }}>
      {children}
    </PracticeContext.Provider>
  )
}

export function usePractice() {
  return useContext(PracticeContext)
}
